import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../../helpers/user";
import Image from "react-graceful-image";

import styles from "./index.module.scss";

const UaFlag = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="72"
    height="72"
    viewBox="0 0 256 256"
    xmlSpace="preserve"
  >
    <g
      style={{
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "none",
        fillRule: "nonzero",
        opacity: 1,
      }}
      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
    >
      <path
        d="M 45 90 C 20.147 90 0 69.853 0 45 h 90 C 90 69.853 69.853 90 45 90 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "rgb(255,213,0)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="matrix(1 0 0 1 0 0)"
        strokeLinecap="round"
      />
      <path
        d="M 45 0 C 20.147 0 0 20.147 0 45 h 90 C 90 20.147 69.853 0 45 0 z"
        style={{
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "rgb(0,91,187)",
          fillRule: "nonzero",
          opacity: 1,
        }}
        transform="matrix(1 0 0 1 0 0)"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

const HeroNew = () => {
  const navigate = useNavigate();
  const enterBtnText = isLoggedIn() ? "Гра" : "Вхід";
  return (
    <section className={styles.bgGradient} id="home" tabIndex="-1">
      <div className={`${styles.padCnt} container`}>
        <h1 className={styles.head}>
          <Image className={styles.logo} src="/logo.svg" alt="" />
        </h1>
        <p className={styles.tagline}>
          Фентезі-футбол - це найпопулярніша у світі гра серед футбольних
          вболівальників, найцікавіший різновид прогнозів. Реальні футболісти
          набиратимуть очки для твоєї віртуальної команди!
        </p>
        <div className={styles.actions}>
          <Button
            onClick={() => navigate("/rules")}
            className={styles.ruleBtn}
            variant="danger"
            size="lg"
          >
            <i className="bi bi-file-ruled"></i>&nbsp;Правила
          </Button>
          <Button
            onClick={() => navigate("/home")}
            size="lg"
            className={`${styles.loginBtn}`}
            variant="primary"
          >
            <i className="bi bi-box-arrow-in-right"></i>&nbsp;{enterBtnText}
          </Button>
        </div>
      </div>
      <div className={styles.imgHolder}>
        <Image src="/cup.png" alt="" className={styles.img} />
        <div className={styles.flagCnt}>
          <UaFlag className={styles.ua} />
        </div>
      </div>
    </section>
  );
};

export default HeroNew;
